import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@emotion/react'

import { FCWithChildren } from '../types'

import theme from '../Theme'

import ErrorBoundary from '@/Components/Common/ErrorBoundary'
import EnvBanner, { Environments } from '@/Components/EnvBanner'

const App: FCWithChildren<{ env?: Environments }> = ({ env, children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        {env && <EnvBanner env={env} />}
        {children}
      </ErrorBoundary>
    </ThemeProvider>
  )
}

export default App
